const getDomPos = (dom) => {
    const r = dom.getBoundingClientRect();
    return {
        x: r.x,
        y: r.y,
    };
};
exports.getDomPos = getDomPos;
